import { render, staticRenderFns } from "./BookNParkDevtoolsPanel.vue?vue&type=template&id=05d03661&scoped=true"
import script from "./BookNParkDevtoolsPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./BookNParkDevtoolsPanel.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BookNParkDevtoolsPanel.vue?vue&type=style&index=0&id=05d03661&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.22_css-loader@6.7.4_webpack@5.102.1__ejs@3.1.1_8e3b2d983739573c8a37493d5fe535f8/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d03661",
  null
  
)

export default component.exports